module.exports = __webpack_public_path__ + "static/media/product-extra-shape.c836de4c.png";